import { defineComponent, ref } from 'vue';
import MinisterListComponent from '@/components/ministerList/MinisterList.vue';
import MinisterFormComponent from '@/components/ministerList/ministerForm/MinisterForm.vue';

export default defineComponent({
  name: 'MinisterPage',
  components: {
    MinisterListComponent,
    MinisterFormComponent,
  },
  setup: () => {
    const ministerId = ref<number | null>(null);
    const ministerForm = ref<InstanceType<typeof MinisterFormComponent>>();

    const createClick = () => {
      Promise.resolve(ministerId.value = null)
        .then(() => ministerForm.value?.show());
    };

    const editClick = (id: number) => {
      Promise.resolve(ministerId.value = id)
        .then(() => ministerForm.value?.show());
    };

    return {
      ministerForm,
      ministerId,
      createClick,
      editClick
    };
  },
});
